import { authService } from 'auth/services';

import { PAGE_TYPE } from 'features/order-tracker/services/constants';
import { formatDate } from 'features/order-tracker/utils/dateUtils';

import { AUTH_STATUS_LOGGED_IN, AUTH_STATUS_NOT_LOGGED_IN } from './constants';

interface AnalyticsProps {
  pageName?: string;
  pageLoadStart?: number;
  trackingError?: string;
  placeholder?: string;
  orderReference?: string;
  milestones?: string;
  timestamp?: string;
}

interface AnalyticsData {
  pageName: string;
  orderReference: string;
  orderMilestones: string;
  loggedInStatus: string;
  timestamp: string;
  apiLoadTime?: number;
  trackingError?: string;
}

class AnalyticsService {
  prepareAnalytics = ({
    pageName = '',
    pageLoadStart,
    trackingError,
    placeholder = '',
    orderReference = '',
    milestones = '',
    timestamp = '',
  }: AnalyticsProps): AnalyticsData => {
    const analyticsData: AnalyticsData = {
      pageName: `BTB:BYA:Track your order:${pageName}`,
      orderReference: placeholder + orderReference,
      orderMilestones: placeholder + milestones,
      loggedInStatus: authService.isAuthenticated() ? AUTH_STATUS_LOGGED_IN : AUTH_STATUS_NOT_LOGGED_IN,
      timestamp,
    };

    if (pageLoadStart) {
      analyticsData.apiLoadTime = (Date.now() - pageLoadStart) / 1000;
    }

    if (trackingError) {
      analyticsData.trackingError = trackingError;
    }

    return analyticsData;
  };

  trackAnalytics = (pageType: string, props?: Record<string, unknown>): void => {
    const analyticsElement = document.querySelector('.component-order-tracker__container');
    const analyticsEvent = new CustomEvent('trackingStep', {
      detail: this.getData(pageType, props),
    });

    if (analyticsElement) {
      analyticsElement.dispatchEvent(analyticsEvent);
    }
  };

  getData = (pageType: string, props?: Record<string, unknown>): AnalyticsData | Record<string, never> => {
    const current = formatDate('YYYY/MM/DD HH:mm:ss');
    switch (pageType) {
      case PAGE_TYPE.waitingRoom:
        return this.prepareAnalytics({
          pageName: PAGE_TYPE.waitingRoom,
          timestamp: current,
        });
      case PAGE_TYPE.orderSummary:
        return this.prepareAnalytics({
          ...props,
          pageName: PAGE_TYPE.orderSummary,
          placeholder: 'OS:',
        });
      case PAGE_TYPE.error:
        return this.prepareAnalytics({
          pageName: PAGE_TYPE.summaryError,
          trackingError: `BTB:BYA:Track your order:Summary error:${props?.trackingError}`,
          timestamp: current,
        });
      default:
        return {};
    }
  };
}

export const analyticsService = new AnalyticsService();
